"use client";

import React from "react";
import Image from "next/image";

interface BeforeAfterPreviewProps {
  toolInfo: {
    id: string;
    title: string;
    imageUrl: string;
  };
}

export default function BeforeAfterPreview({ toolInfo }: BeforeAfterPreviewProps) {
  // Don't show BeforeAfterPreview for ai-designer tool
  if (toolInfo.id === 'ai-designer') {
    return null;
  }

  return (
    <div className="w-full max-w-sm mx-auto mb-8 hidden md:block">
      <div className="relative">
        {/* Tool Title */}
        <div className="text-center mt-6 mb-6">
          <h3 className="text-lg font-medium text-gray-800 mb-1">
            {toolInfo.title}
          </h3>
          <p className="text-sm text-gray-500">
            Upload your photo, pick styles to see the changes
          </p>
        </div>
        {/* Before and After Images Container */}
        <div className="flex items-center justify-center gap-4">
          {/* Before Image */}
          <div className="flex-1 text-center">
            <div className="relative">
              <Image
                src="/assets/images/tools/before.png"
                alt="Before"
                width={120}
                height={120}
                className="rounded-lg shadow-md object-cover mx-auto bg-[#7A7B77]"
              />
              <div className="absolute -bottom-2 left-1/2 transform -translate-x-1/2">
                <span className="bg-gray-600 text-white text-xs px-2 py-1 rounded-full">
                  Before
                </span>
              </div>
            </div>
          </div>

          {/* Arrow */}
          <div className="flex-shrink-0">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="text-primary"
            >
              <path
                d="M5 12H19M19 12L12 5M19 12L12 19"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>

          {/* After Image */}
          <div className="flex-1 text-center">
            <div className="relative">
              <Image
                src={toolInfo.imageUrl}
                alt="After"
                width={120}
                height={120}
                className="rounded-lg shadow-md object-cover mx-auto"
              />
              <div className="absolute -bottom-2 left-1/2 transform -translate-x-1/2">
                <span className="bg-primary text-white text-xs px-2 py-1 rounded-full">
                  After
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
